async function CancelarConsulta(fecha, horario) {
    
    // Detectar entorno: Desarrollo (localhost) vs Producción
    const BASE_URL = window.location.hostname === "localhost" 
        ? "http://localhost:4000" 
        : "https://vetladradoc.uy";

    try {
        const response = await fetch(`${BASE_URL}/api/consulta/delete`, {
            method: "POST",
            // IMPORTANTE: Esto permite que viajen las cookies de Passport
            credentials: "include", 
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                fecha: fecha,
                horario: horario
            }),
        });

        // Opcional: Si el servidor responde 401 o 403, es que la sesión expiró
        if (response.status === 401) {
            console.warn("La sesión ha expirado.");
        }

        return response;
    } catch (error) {
        console.error("Error en la conexión al intentar cancelar:", error);
        throw error;
    }
}

export default CancelarConsulta;